import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.input`
  position: absolute;
  top: 0;
  left: 0;
  padding: 0;
  margin: 0;
  opacity: 0;
  width: 100%;
  height: 100%;

  & + svg {
    display: none;
  }

  &:checked + svg {
    display: block;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    cursor: pointer;
  }
`;
